import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { usePutImageUpload } from "../../api/products";
import { ProductRequest } from "../../models/Product";
import { imageFields } from "../../pages/reward-inventory-portal/create-product/CreateProduct.const";
import { useFormStore } from "../../stores/formStore";

const useFormImageUpload = () => {
  const { imageFiles, imageCount, resetImages } = useFormStore(state => ({
    imageFiles: state.imageFiles,
    imageCount: state.imageCount,
    resetImages: state.resetImages,
  }));

  const formContext = useFormContext<ProductRequest>();
  const { mutateAsync: putImageAsync } = usePutImageUpload();

  const productCountry = formContext.watch("productDetails.productCountry");

  const uploadImages = useCallback(async () => {
    if (!imageCount) {
      return;
    }

    const uploadPromises = imageFields.map(imageField => {
      const image = imageFiles[imageField];

      if (!image || !productCountry) return null;

      return putImageAsync({
        image,
        countryCode: productCountry,
      });
    });

    const uploads = await Promise.all(uploadPromises);

    imageFields.forEach((imageField, index) => {
      const cloudfrontUrl = uploads[index];

      if (cloudfrontUrl) {
        formContext.setValue(imageField, cloudfrontUrl);
      }
    });

    resetImages();
  }, [imageCount, imageFields, imageFiles, productCountry, resetImages]);

  return uploadImages;
};

export default useFormImageUpload;
